import { SET_SAMPLE_LABEL } from "../mutation.type"
import Vue from "vue";

const state = {
  sampleLabel: null,
}
const mutations = {
  [SET_SAMPLE_LABEL]: (state, detail) =>{
    Vue.set(state, "sampleLabel", detail)
  }
}

export default {
  state,
  mutations
}